import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(4, 6, 4, 8),
    backgroundColor: theme.colorPalette.beige_25
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2)
  },
  title: {
    fontSize: 16,
    fontWeight: 400,
    color: theme.colorPalette.green_90
  },
  resetButton: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    fontSize: 12,
    fontWeight: 600,
    '&:hover': {
      background: 'transparent'
    }
  },
  resetIcon: {
    width: 24,
    height: 24
  },
  groups: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(4)
  },
  group: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(4),
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colorPalette.beige_40,
    // Both groups stretch to the card edge, so stacked rows don't stagger and a shared row fills it.
    flexGrow: 1
  },
  tooltip: {
    margin: theme.spacing(0, 1),
    backgroundColor: theme.colorPalette.green_75,
    fontSize: 10
  },
  options: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(4)
  },
  checkbox: {
    marginBottom: 0,
    minHeight: 0
  }
}));
